import { postFormData } from './requests';

const uploadFile = (
  url: string,
  name: string,
  fileName: string,
  allowedExtensions = '',
) => {
  const input = document.createElement('input');

  const promise = new Promise((resolve, reject) => {
    input.onchange = (event: Event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (!file) return;

      const formData = new FormData();
      formData.append(name, file, fileName);

      postFormData(url, formData).then(resolve).catch(reject);

      input.remove();
    };
  });

  input.type = 'file';
  input.accept = allowedExtensions;

  document.body.appendChild(input);
  input.click();

  return promise;
};

export default uploadFile;
